// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';

export const Form = (el) => {
  const ui = {
    el,
    body: select('body', document),
    urlSelect: select('.js-url-select', el),
  };

  const handleRedirect = () => {
    const urlValue = ui.urlSelect.value;

    if (urlValue && urlValue !== '--select--') {
      // Check if we're in an iframe (Storybook)
      if (window.self !== window.top) {
        window.open(urlValue, '_blank');
      } else {
        window.location.href = urlValue;
      }
    }
  };

  const addEvents = () => {
    ui.el.addEventListener('submit', (el) => {
      if (ui.el.classList.contains('js-url-redirect')) {
        el.preventDefault();
        handleRedirect();
      }
    });
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default Form;
